import { AnyAction } from 'redux';
import { initialState } from './initialState';
import { IStore } from './IStore';
import { ReducerActions } from '../enums/ReducerActions';

export const rootReducer = (state = initialState, action: AnyAction): IStore => {
    switch (action.type) {
        case ReducerActions.FETCH_APPLICATION_SETTINGS_SUCCEEDED:
            return {
                ...state,
                applicationSettings: action.appSettings,
            };
        case ReducerActions.FETCH_APPLICATION_SETTINGS_FAILED:
            return {
                ...state,
                applicationSettings: {}
            };     
        case ReducerActions.UPDATE_CONFIGURATION: {
                return {
                    ...state,
                    configurations: action.configurations
                }
            }   
        case ReducerActions.FETCH_TRANSLATIONS_SUCCEEDED: {
            return {
                ...state,
                translations: action.translations
            }
        }
        case ReducerActions.FETCH_LANGUAGES_SUCCEEDED: {
            return {
                ...state,
                languages: action.languages,
            }
        }
        default:
            return state;
    }
};
